<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.redPacket')"
    resource="red_packets"
    :onFetchData="onFetchData"
    :beforeSubmit="beforeSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/red_packets.js';
import _ from 'lodash';
import CustomListItemColumns from './custom_list/custom_list_item_columns';
import CustomListItemFormColumns from './custom_list/custom_list_item_form_columns';

@Component
export default class RedPackets extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {
    type: 'RedPacket::Brand',
    code: '',
    kind: 'cash',
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'brand_name_cont',
      'code_cont',
      {
        key: 'type_eq',
        renderCell: {
          components: 'select',
          props: {
            options: _.map(_.pickBy(this.$t('redPacket.types'), (v, k) => k !== 'RedPacket::Joga'), (label, value) => ({ label, value }))
          }
        }
      },
      'state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'code',
      {
        key: 'type',
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$t(`redPacket.types.${value}`) }</span>;
        }
      },
      'total_amount',
      'quantity',
      {
        key: 'state',
        width: 110,
      },
      {
        key: 'expired_at',
        width: 160,
      },
      'brand',
      type === 'show' && 'received_count',
      type === 'show' && 'received_amount',
      type === 'show' && {
        prop: 'user',
        label: this.$t('model.user'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'users.show', params: { id: value.id } }}>{ value.miapay_wallet_holder_attributes.phone }</bean-link>;
          }
        }
      },
      type === 'show' && {
        key: 'qrcode',
        renderCell: 'storageAttachment'
      },
      type === 'show' && {
        prop: 'custom_list_item_attributes',
        label: this.$t('redPacket.customListItem'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-table height={null} value={[value]} columns={CustomListItemColumns.call(this, { ...value, kind: 'image' })} />
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'brand_id',
        label: this.$t('model.brand'),
      },
      {
        key: 'code',
        renderCell: {
          props: {
            disabled: true,
          }
        }
      },
      {
        key: 'total_amount',
        renderCell: {
          hint: this.$t('hint.cannotChangeAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
      {
        key: 'quantity',
        renderCell: {
          hint: this.$t('hint.cannotChangeAfterCreate'),
          required: true,
          props: {
            disabled: type === 'edit',
          }
        }
      },
      (type === 'new' || ['init', 'actived'].includes(data.state)) && 'expired_at',
      {
        prop: 'custom_list_item_attributes',
        label: this.$t('redPacket.customListItem'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: () => {
              const row = data.custom_list_item_attributes || {};
              return CustomListItemFormColumns.call(this, row, { ...data, kind: 'image' });
            },
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      row.type === 'RedPacket::Brand' && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'red_packets.edit', params: { id: row.id } }
        }
      },
      // 红包过期退回金额时，如果用户钱包余额达到上限，导致退回失败，需由管理员手动操作
      row.type === 'RedPacket::Normal' && row.state === 'expired' && row.remaining_amount > 0 && {
        component: 'button',
        props: {
          label: this.$t('redPacket.manuallyReturn'),
          type: 'danger',
          can: 'red_packets.manually_return',
        },
        on: {
          click: async () => {
            await this.$confirm(`${this.$t('bean.actionConfirm')} ${this.$t('redPacket.manuallyReturn')} ${row.remaining_amount} FCFA?`, '');
            await this.$request.put(`/red_packets/${row.id}/manually_return`);
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.type === 'RedPacket::Brand' && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'red_packets.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/red_packets', { params: { ...this.$route.query, type_not_eq: 'RedPacket::Joga' } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/red_packets/${this.$route.params.id}`);
      if (type === 'edit') {
        const item = data.custom_list_item_attributes;
        switch (_.get(item, 'target_type')) {
          case ('Merchant'):
            item.merchant_id = item.target_id;
            break;
          case ('TicketEvent'):
            item.ticket_event_id = item.target_id;
            break;
        }
      }
      return { data };
    }

    if (type === 'new') {
      const data = await this.$request.get('/red_packets/get_uniq_code');
      return {
        data: {
          ...this.form,
          ...data,
        }
      };
    }
  }

  beforeSubmit({ data }) {
    const formBody = _.cloneDeep(data);
    const item = formBody.custom_list_item_attributes;
    switch (_.get(item, 'target_type')) {
      case ('Merchant'):
        item.target_id = item.merchant_id;
        delete item.merchant_id;
        break;
      case ('TicketEvent'):
        item.target_id = item.ticket_event_id;
        delete item.ticket_event_id;
        break;
    }
    return formBody;
  }
}

export const route = [
  {
    path: '/red_packets',
    name: 'red_packets.index',
    component: RedPackets,
    props: {
      type: 'index',
    }
  },
  {
    path: '/red_packets/new',
    name: 'red_packets.new',
    component: RedPackets,
    props: {
      type: 'new',
    }
  },
  {
    path: '/red_packets/:id',
    name: 'red_packets.show',
    component: RedPackets,
    props: {
      type: 'show',
    }
  },
  {
    path: '/red_packets/:id/edit',
    name: 'red_packets.edit',
    component: RedPackets,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style scoped lang="scss">
  /deep/.admin-static-nest-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
</style>
